import React from "react";
import { MdOutlineSos } from "react-icons/md";
import { RiHomeOfficeFill } from "react-icons/ri";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { FaHandshake } from "react-icons/fa";
import { IoIosArrowForward } from "react-icons/io";
import { hoaLabel } from "../../../utils/constants";

function QuickContactsSection() {
  const requestTypes = [
    {
      label: "Emergency",
      icon: <MdOutlineSos />,
      link: "/sos",
    },
    {
      label: hoaLabel,
      icon: <RiHomeOfficeFill />,
      link: "/condo-corp",
    },
    {
      label: "Suppliers",
      icon: <FaHandshake />,
      link: "/suppliers",
    },
    {
      label: "Others",
      icon: <HiOutlineDotsHorizontal />,
      link: "/other-services",
    },
  ];

  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl shadow-sm px-4 py-5 mt-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-sm font-semibold text-[#363062]">Contacts</h2>
      </div>

      <div className="grid grid-cols-4 gap-3">
        {requestTypes.map((request, index) => (
          <div
            key={index}
            onClick={() => navigate(`${request.link}`)}
            className="flex flex-col items-center cursor-pointer transition-transform active:scale-95 h-18"
          >
            <div className="text-3xl text-eleghoBlue mb-1">{request.icon}</div>
            <span className="text-[10px] font-medium text-center text-gray-700 mt-1">
              {request.label}
            </span>
          </div>
        ))}
      </div>

      {/* <div className="mt-5 border border-gray-100 rounded-xl p-3 shadow-sm">
        <div className="flex items-center">
          <div className="flex-1">
            <h3 className="text-[#363062] text-xs font-semibold">Directory</h3>
            <p className="text-[10px] text-gray-500 mt-0.5">
              View all contact information
            </p>
          </div>
          <button
            className="flex items-center text-[#363062] text-xs"
            onClick={() => navigate("/contacts/directory")}
          >
            <span className="mr-1 font-medium">View</span>
            <IoIosArrowForward />
          </button>
        </div>
      </div> */}
    </div>
  );
}

export default QuickContactsSection;
